/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    TicketingSettings,
    TicketingSettingsFromJSON,
    TicketingSettingsFromJSONTyped,
    TicketingSettingsToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityProviderSettingsListItem
 */
export interface IdentityProviderSettingsListItem {
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsListItem
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof IdentityProviderSettingsListItem
     */
    provider?: GuidIdAndLabel;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof IdentityProviderSettingsListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof IdentityProviderSettingsListItem
     */
    distributionChannel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof IdentityProviderSettingsListItem
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {Array<TicketingSettings>}
     * @memberof IdentityProviderSettingsListItem
     */
    ticketingSettings?: Array<TicketingSettings> | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsListItem
     */
    allowEdit?: boolean;
}

export function IdentityProviderSettingsListItemFromJSON(json: any): IdentityProviderSettingsListItem {
    return IdentityProviderSettingsListItemFromJSONTyped(json, false);
}

export function IdentityProviderSettingsListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityProviderSettingsListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'provider': !exists(json, 'provider') ? undefined : GuidIdAndLabelFromJSON(json['provider']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannel': !exists(json, 'distributionChannel') ? undefined : Int32IdAndLabelFromJSON(json['distributionChannel']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'ticketingSettings': !exists(json, 'ticketingSettings') ? undefined : (json['ticketingSettings'] === null ? null : (json['ticketingSettings'] as Array<any>).map(TicketingSettingsFromJSON)),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function IdentityProviderSettingsListItemToJSON(value?: IdentityProviderSettingsListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'provider': GuidIdAndLabelToJSON(value.provider),
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannel': Int32IdAndLabelToJSON(value.distributionChannel),
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'ticketingSettings': value.ticketingSettings === undefined ? undefined : (value.ticketingSettings === null ? null : (value.ticketingSettings as Array<any>).map(TicketingSettingsToJSON)),
        'allowEdit': value.allowEdit,
    };
}


